import React from 'react';
import { colour } from '../styles/GlobalStyles';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';

function CustomSlider(props) {
    const value = props.value;
    const disabled = props.disabled;
    const label = props.label;
    const onChange = props.onChange;
    const min = props.min;
    const max = props.max;
    const step = props.step;
    return (
        <Stack
            sx={{
                width: '100%'
            }}
        >
            <Slider
                aria-label={label}
                value={value}
                onChange={onChange}
                min={min}
                max={max}
                step={step}
                disabled={disabled}
                sx={{
                    color: colour.gray05,
                    width: '100%',
                    height: '5px',
                    padding: 0,
                    '& .MuiSlider-track': {
                        border: 'none'
                    },
                    '& .MuiSlider-thumb': {
                        width: 24,
                        height: 24,
                        backgroundColor: colour.gray00,
                        '&:hover, &.Mui-focusVisible, &.Mui-active': {
                            boxShadow: 'none',
                        },
                    }
                }}
            />
        </Stack>
    )
};

export default CustomSlider;